import ApiBuilder from "./ApiBuilder"
const { API } = ApiBuilder

const createRelease = async (release) => {
  return API.post(`/api/release`, release)
}

const getPendingReviews = async (page, pageSize) => {
  const odata = `$expand=Application($expand=ApplicationCategory)`
  return API.get(`/api/release/pending-review-releases?page=${page}&pageSize=${pageSize}&${odata}`)
}

const getReleaseById = async (releaseId) => {
  return API.get(`/api/release/${releaseId}`)
}

const getAdminCommentsByApplicationId = (globalApplicationId) => {
  return API.get(`/api/Release?$select=Version,CommentByAdmin&$filter=GlobalApplicationId eq ${globalApplicationId} and CommentByAdmin ne null&$expand=CommentByAdmin($select=CommentText)&$orderby=Version desc`)
}

const submitReviewForRelease = async (releaseId, approve = false, comment) => {
  return API.put(`/api/release/${releaseId}/review?approve=${approve}`, comment)
}

const getReleasesForApplication = (globalApplicationId, additionalODataFilter = null) => {
  let filter = `GlobalApplicationId eq ${globalApplicationId} ${additionalODataFilter ? additionalODataFilter : ''}`
  const odata = `$select=Id,Version&$filter=${filter}&$orderby=Version asc`
  return API.get(`/api/Release?${odata}`)
}

export default {
  createRelease,
  getPendingReviews,
  getReleaseById,
  submitReviewForRelease,
  getAdminCommentsByApplicationId,
  getReleasesForApplication
}